import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SEMANTIC, UI } from '../../styles/theme';
import API from '../../api';

const COUNTRY_KEYS = {
  IT: 'kyc.fatca.country_IT',
  US: 'kyc.fatca.country_US',
  GB: 'kyc.fatca.country_GB',
  DE: 'kyc.fatca.country_DE',
  FR: 'kyc.fatca.country_FR',
  ES: 'kyc.fatca.country_ES',
  CH: 'kyc.fatca.country_CH',
  OTHER: 'kyc.fatca.country_OTHER',
};

const FatcaSettings = ({ userId }) => {
  const { t } = useTranslation();
  const [fatca, setFatca] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;
    API.get(`/users/${userId}/fatca`)
      .then(res => setFatca(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [userId]);

  if (loading) return null;

  const yesNo = (val) => {
    if (val === 'yes') return t('kyc.fatca.yes');
    if (val === 'no') return t('kyc.fatca.no');
    return <span style={{ color: '#555' }}>{t('settings.not_set')}</span>;
  };

  const country = (code) => {
    if (!code) return <span style={{ color: '#555' }}>{t('settings.not_set')}</span>;
    return COUNTRY_KEYS[code] ? t(COUNTRY_KEYS[code]) : code;
  };

  const rows = [
    { label: t('kyc.fatca.q1').replace(' *', ''), value: yesNo(fatca?.fatca_us_citizen) },
    { label: t('kyc.fatca.q2').replace(' *', ''), value: yesNo(fatca?.fatca_us_residency) },
    { label: t('kyc.fatca.q3').replace(' *', ''), value: yesNo(fatca?.fatca_has_tin) },
    ...(fatca?.fatca_has_tin === 'yes' ? [{ label: t('kyc.fatca.tin_label').replace(' *', ''), value: fatca?.fatca_tin_number || '—' }] : []),
    { label: t('kyc.fatca.birth_country').replace(' *', ''), value: country(fatca?.fatca_birth_country) },
    { label: t('kyc.fatca.tax_country').replace(' *', ''), value: country(fatca?.fatca_tax_residence_country) },
  ];

  return (
    <div style={{ backgroundColor: SEMANTIC.backgroundCard, borderRadius: UI.borderRadius.md, padding: UI.spacing.xl, marginBottom: UI.spacing.xl, boxShadow: UI.shadow.card }}>
      <div style={{ marginBottom: UI.spacing.lg, paddingBottom: UI.spacing.sm, borderBottom: '1px solid #333' }}>
        <h3 style={{ color: SEMANTIC.actionBuy, fontSize: UI.fontSize.lg, fontWeight: UI.fontWeight.bold, margin: 0 }}>
          {t('settings.section_fatca')}
        </h3>
        {fatca?.fatca_completed_at && (
          <p style={{ color: SEMANTIC.textSecondary, fontSize: UI.fontSize.sm, margin: `${UI.spacing.xs} 0 0` }}>
            {t('settings.fatca_completed_on', { date: fatca.fatca_completed_at })}
          </p>
        )}
      </div>

      {!fatca?.fatca_completed_at ? (
        <p style={{ color: SEMANTIC.textSecondary }}>{t('settings.fatca_no_data')}</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: UI.spacing.sm }}>
          {rows.map(({ label, value }) => (
            <div key={label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: `${UI.spacing.sm} 0`, borderBottom: '1px solid #222' }}>
              <span style={{ color: SEMANTIC.textSecondary, fontSize: UI.fontSize.sm, flex: 1 }}>{label}</span>
              <span style={{ color: SEMANTIC.textPrimary, fontSize: UI.fontSize.md, fontWeight: UI.fontWeight.bold, marginLeft: UI.spacing.md, textAlign: 'right' }}>{value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FatcaSettings;
